import { PencilIcon } from "@heroicons/react/24/outline";

import { Button } from "../../../../../../../components/ui";
import AddSalesPerson from "./AddSalesPerson";
import { formattedLocaleISODate } from "../../../../../../../util";
import { formatSplitPercentage } from "./salesPersonSplitUtils";

const SalesPersonSection = props => {
  const { formik, invoice, hasPermission } = props;
  const invoiceSalesPersons = formik?.values?.invoiceSalesPersons || [];
  const hasSalesPersons = invoiceSalesPersons.length > 0;
  const splitUpdatedAt = invoiceSalesPersons.find(
    salesPerson => salesPerson?.timestamp,
  )?.timestamp;

  const canEdit = hasPermission("UPDATE_INVOICE_SALES_PERSON");

  return (
    <div className="mt-4">
      {hasSalesPersons ? (
        <div className="overflow-hidden rounded border border-black">
          <table className="w-full table-fixed border-collapse">
            <colgroup>
              <col className="w-2/3" />
              <col className="w-1/3" />
            </colgroup>
            <thead>
              <tr className="border-b border-black bg-gray-50 text-xs font-semibold uppercase tracking-wide text-gray-500">
                <th className="px-4 py-3 text-left">
                  <span className="text-sm font-bold flex-1">Sales Person</span>
                </th>
                <th className="px-4 py-3 text-left">
                  <div className="flex items-center gap-2">
                    <span className="text-sm font-bold flex-1">Split</span>
                    {canEdit && (
                      <AddSalesPerson
                        invoice={invoice}
                        trigger={
                          <Button
                            action="black"
                            customPadding="p-1"
                            className="text-xs"
                            icon={<PencilIcon className="h-4 w-4" />}
                          />
                        }
                      />
                    )}
                  </div>
                </th>
              </tr>
            </thead>
            <tbody>
              {invoiceSalesPersons.map((salesPerson, index) => (
                <tr
                  key={salesPerson?.id ?? `${salesPerson?.salesUserId}-${index}`}
                  className="border-b border-black last:border-b-0"
                >
                  <td className="px-4 py-3 align-top">
                    <div className="min-w-0">
                      <div className="truncate text-sm text-gray-900">
                        {salesPerson?.salesUser?.name || `Split ${index + 1}`}
                      </div>
                      <div className="truncate text-xs text-gray-500">
                        {salesPerson?.invoiceSalesPersonType?.name || ""}
                      </div>
                    </div>
                  </td>
                  <td className="px-4 py-3 align-top text-sm text-gray-900 text-right">
                    {salesPerson?.split != null
                      ? formatSplitPercentage(salesPerson.split)
                      : ""}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : null}
      {hasSalesPersons && splitUpdatedAt ? (
        <div className="mt-2 text-right text-xs text-gray-500">
          {formattedLocaleISODate(splitUpdatedAt)}
        </div>
      ) : canEdit ? (
        <AddSalesPerson
          invoice={invoice}
          trigger={
            <div className="cursor-pointer rounded border border-dashed border-gray-300 py-6 text-center text-gray-500 transition-colors hover:border-gray-400 hover:bg-gray-50 hover:text-gray-700">
              Add sales person
            </div>
          }
        />
      ) : null}
    </div>
  );
};

export default SalesPersonSection;
